import Vue from 'vue'
import Router from 'vue-router'
import mixins from './mixins';

Vue.use(Router)

const router = new Router({
	mode: process.env.VUE_APP_ROUTER_MODE,
	base: process.env.BASE_URL,
	scrollBehavior () {
		return { x: 0, y: 0 }
	},
	routes: [

		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: '',
			component: () => import('./layouts/main/Main.vue'),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: '/',
					name: 'home',
					component: () => import('./views/Home.vue'),
				},
				{
					path: '/home',
					name: 'back-home',
					component: () => import('./views/Home.vue'),
				},
				{	
					path: '/restauracao/restaurante-val-moreira-comida',
					name: 'restaurante-val-moreira-comida',
					component: () => import('./views/pages/RestauranteValMoreiraCarta.vue'),
				},	  
				{	
					path: '/restauracao/restaurante-val-moreira-bebidas',
					name: 'restaurante-val-moreira-bebidas',
					component: () => import('./views/pages/RestauranteValMoreiraBebidas.vue'),
				},	  
				{	
					path: '/geral/directorio',
					name: 'directorio',
					component: () => import('./views/pages/Directorio.vue'),
				},	  
				{	
					path: '/geral/questionario',
					name: 'questionario',
					component: () => import('./views/pages/Questionario.vue'),
				},	  
				{	
					path: '/geral/fire',
					name: 'fire',
					component: () => import('./views/pages/Fire.vue'),
				},	  
				{	
					path: '/geral/estadia',
					name: 'estadia',
					component: () => import('./views/pages/Estadia.vue'),
				},	  
				{	
					path: '/geral/checkin',
					name: 'checkin',
					component: () => import('./views/pages/Checkin.vue'),
				},	  
				{	
					path: '/geral/old-estadias',
					name: 'estadiasAnteriores',
					component: () => import('./views/pages/EstadiasAnteriores.vue'),
				},	  
				{	
					path: '/geral/feedback',
					name: 'feedback',
					component: () => import('./views/pages/Feedback.vue'),
				},	  
				{
					path: '/geral/wake-up',
					name: 'wakeUp',
					component: () => import('./views/pages/Wakeup.vue'),
				},
				{
					path: '/geral/dont-disturb',
					name: 'dontDisturb',
					component: () => import('./views/pages/DontDisturb.vue'),
				},
				{
					path: '/geral/suporte',
					name: 'suporte',
					component: () => import('./views/pages/Suporte.vue'),
				},
				{
					path: '/geral/wine-olive',
					name: 'wineOlive',
					component: () => import('./views/eCommerce/ECommerceShop.vue'),
				},
				{
                    path: '/eCommerce/shop',
                    name: 'eCommerceShop',
                    component: () => import('./views/eCommerce/ECommerceShop.vue'),
                    meta: {
                        pageTitle: 'Shop',
                        rule: 'editor'
                    }
				},
				{
					path: '/geral/room-service/:hotelId?',
					name: 'cartas-room-service',
					meta: {
						page_title_i18n: 'CartasSide',
						category_type: ['room-service'],
						with_id_cat_null: false
					},
					component: () => import('./views/pages/Menus.vue'),
				}, 
				{
					path: '/geral/spa/:hotelId?',
					name: 'spa',
					meta: {
						page_title_i18n: 'Spa',
						category_type: ['spa'],
						with_id_cat_null: false
					},
					component: () => import('./views/pages/Menus.vue'),
				},               
				{
					path: '/geral/menus/:hotelId?',
					name: 'menus',
					meta: {
						page_title_i18n: 'CartasSide',
						category_type: ['menu', 'room-service'],
						with_id_cat_null: true
					},
					component: () => import('./views/pages/Menus.vue'),
				},
				{
					path: '/geral/laundry/:hotelId?',
					name: 'laundry',
					meta: {
						page_title_i18n: 'laundry',
						category_type: ['laundry'],
						with_id_cat_null: false
					},
					component: () => import('./views/pages/Menus.vue'),
				},
                {
                    path: '/eCommerce/wish-list',
                    name: 'eCommerceWishList',
                    component: () => import('./views/eCommerce/ECommerceWishList.vue'),
                    meta: {
                        pageTitle: 'Wish List',
                        rule: 'editor'
                    }
                },
                {
					path: '/eCommerce/checkout',
                    name: 'eCommerceCheckout',
                    component: () => import('./views/eCommerce/ECommerceCheckout.vue'),
                    meta: {
                        rule: 'editor'
                    }
				},
				{
					path: '/eCommerce/orders',
                    name: 'eCommerceOrderCompleated',
                    component: () => import('./views/eCommerce/ECommerceOrderCompleated.vue'),
				},
				{
					path: '/account',
                    name: 'account',
                    component: () => import('./views/eCommerce/ECommerceAccount.vue'),
				},
				{
					path: '/reservation/checkout',
                    name: 'rsvCheckOut',
                    component: () => import('./views/pages/RsvCheckout.vue'),
				},
				{
					path: '/admin/content',
                    name: 'admin-content',
                    component: () => import('./views/admin/Content.vue'),
				},
				{
					path: '/user/profile',
                    name: 'user-profile',
                    component: () => import('./views/components/Profile.vue'),
                    meta: {
						category: 'information',
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						  	/*{ trans: 'Informations', active: true }*/
						],
						pageTrans: 'Clube'
					}
				},
				{
					path: '/admin/content/main',
                    name: 'admin-content-main',
                    component: () => import('./views/admin/main/MainContent.vue'),
				},
				{
					path: '/admin/content/cartas',
                    name: 'admin-content-cartas',
                    component: () => import('./views/admin/CartasContent.vue'),
				},
				{
					path: '/admin/content/capitulos',
                    name: 'admin-content-capitulos',
                    component: () => import('./views/admin/CapituloContent.vue'),
				},
				{
					path: '/admin/content/sub-capitulos',
                    name: 'admin-content-sub-capitulos',
                    component: () => import('./views/admin/SubCapituloContent.vue'),
				},
				{
					path: '/admin/content/menu-setup',
                    name: 'admin-menu-setup',
                    component: () => import('./views/admin/MenuSetup.vue'),
				},
				{
					path: '/admin/users',
                    name: 'admin-users',
                    component: () => import('./views/admin/Users.vue'),
                    meta: {
						permission: [3],
                    }
				},
				{
				    path: '/news/list',
                    name: 'list-news',
                    component: () => import('./views/news/List.vue'),
                    meta: {
                        permission: [2, 3],
                    }
                },
                {
                    path: '/news/list/news-form/:id?',
                    name: 'news-form',
                    component: () => import('./views/news/News_form.vue'),
                    meta: {
                        permission: [2, 3],
                    }
                },
                {
	                path: '/news/show',
	                name: 'news-show',
	                component: () => import('./views/news/News_show.vue'),
	                meta: {
	                	breadcrumb: [
                        	{ trans: 'Home', url: '/' },
                         	{ trans: 'Noticias', active: true }
                        ],
                        pageTrans: 'Noticias'
                    }
                },
                {
                    path: '/news/show/:id',
                    name: 'news-show-single',
                    component: () => import('./views/news/News_show_single.vue'),
                    meta: {
                        breadcrumb: [
                            { trans: 'Home', url: '/' },
                            { trans: 'Noticias', url: {name: 'news-show'} },
                            { trans: 'Noticia', active: true }
                        ],
                        pageTrans: 'Noticia'
                    }
                },
				{
					path: '/geral/informations',
					name: 'informations',
					component: () => import('./views/pages/Informations.vue'),
					meta: {
						category: 'information',
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						  	{ trans: 'Informations', active: true }
						],
						pageTrans: 'Informations'
					}

				},
				{
					path: '/booking/new',
					name: 'bookings',
					component: () => import('./views/pages/Booking.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						],
						pageTrans: 'appointments',
					}
				},
				{
					path: '/my-bookings',
					name: 'my_bookings',
					component: () => import('./views/pages/MyBooking.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						],
						pageTrans: 'appointments',
					}
				},
				{
					path: '/geral/entertainment',
					name: 'entertainment',
					component: () => import('./views/pages/Informations.vue'),
					meta: {
						category: 'entertainment',
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						  	{ trans: 'Entretenimento', active: true }
						],
						pageTrans: 'Entretenimento'
					},
				},
				{
					path: '/geral/event/list',
					name: 'event-list',
					component: () => import('./views/pages/Event_list.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' }
						],
						pageTrans: 'Eventos',
						permission: [2, 3],
					}
				},
				{
					path: '/geral/event/list/event-form/:id?',
					name: 'event-form',
					component: () => import('./views/pages/Event_form.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
                            { trans: 'Eventos', url: {name: 'event-list'} },
                            { title: 'Novo', active: true }
						],
						pageTrans: 'Eventos',
						permission: [2, 3],
					}
				},
				{
					path: '/geral/vgstar',
					name: 'vgstar',
					component: () => import('./views/pages/Vgstar.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						],
						pageTrans: 'VilaGaleSTAR',
						staff: true,
					}
				},
				{
					path: '/geral/inovar-motivar',
					name: 'inovar-motivar',
					component: () => import('./views/pages/Inovar_motivar.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						],
						pageTrans: 'Inovar_Motivar',
						staff: true,
					}
				},
				{
					path: '/admin/content/gerirConteudos/list',
					name: 'content-list',
					component: () => import('./views/pages/gerirConteudos_list.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' }
						],
						pageTrans: 'gerirConteudos',
						permission: [2, 3, 4],
					}
				},
				{
					path: '/admin/content/gerirConteudos/form/:id?',
					name: 'content-form',
					component: () => import('./views/pages/gerirConteudos_form.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
                            { trans: 'gerirConteudos', url: {name: 'content-list'} },
                            { title: 'Novo', active: true }
						],
						pageTrans: 'gerirConteudos',
						permission: [2, 3, 4],
					}
				},
				{
					path: '/geral/parcerias',
					name: 'parcerias',
					component: () => import('./views/pages/Parcerias_show.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						],
						pageTrans: 'Parcerias',
						staff: true,
					}
				},
				{
					path: '/admin/parcerias/list',
					name: 'parcerias-list',
					component: () => import('./views/pages/Parcerias_list.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' }
						],
						pageTrans: 'Parceriass',
						permission: [2, 3],
					}
				},
				{
					path: '/admin/parcerias/form/:id?',
					name: 'parcerias-form',
					component: () => import('./views/pages/Parcerias_form.vue'),
					meta: {
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
                            { trans: 'Parceriass', url: {name: 'parcerias-list'} },
                            { title: 'Novo', active: true }
						],
						pageTrans: 'Parceriass',
						permission: [2, 3],
					}
				},
				{
					path: '/geral/schedule',
					name: 'geral/schedule',
					component: () => import('./views/pages/Schedule.vue'),
					meta: {
					 
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						  	
						],
						pageTrans: 'horarios'
					},
				},
			],
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: '',
			component: () => import('@/layouts/full-page/FullPage.vue'),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================
				{
					path: '/login',
					name: 'pageLogin',
					component: () => import('@/views/pages/Login.vue'),
					meta: {
						public: true,
					}
				},
				{
					path: '/recover/:r/:lang',
					name: 'recover',
					component: () => import('@/views/pages/Recover.vue'),
					meta: {
						public: true,
					}
				},
				{
					path: '/pages/error-404',
					name: 'pageError404',
					component: () => import('@/views/pages/Error404.vue'),
					meta: {
						public: true,
					}
				},
				{
					path: '/welcome',
					name: 'welcome',
					component: () => import('./views/components/WelcomePopup.vue'),
				},
				{
					path: '/internal/bookings/:hotelId/:interface/:token/:pos?',
					name: 'int_bookings',
					component: () => import('./views/pages/Booking.vue'),
					meta: {
						public: true,
					}
				},
				{
					path: '/internal/my_bookings/:hotelId/:interface/:token/:pos?',
					name: 'int_my_bookings',
					component: () => import('./views/pages/MyBooking.vue'),
					meta: {
						public: true
					}
				},
				{
					path: '/public/menu/:hotelId?/:lang?',
					name: 'public-menu',
					component: () => import('./views/pages/Menus.vue'),
					meta: {
						page_title_i18n: 'CartasSide',
						public: true,
						category_type: ['menu', 'spa', 'room-service'],
						with_id_cat_null: true,
					}
				},
				{
					path: '/public/entertainment/:hotelId?/:lang?',
					name: 'public-entertainment',
					component: () => import('./views/pages/Informations.vue'),
					meta: {
						public: true,
						category: 'entertainment',
						breadcrumb: [
						  	{ trans: 'Home', url: '/' },
						  	{ trans: 'Entretenimento', active: true }
						],
						pageTrans: 'Entretenimento'
					}
				},
				{
					path: '/public/schedule',
					name: 'public-schedule',
					component: () => import('./views/pages/Schedule.vue'),
					meta: {
						public: true,
						meta: {
							breadcrumb: [
							  	{ trans: 'Home', url: '/' },
							  	
							],
							pageTrans: 'horarios'
						},
					}
				},
				{
					path: '/new-password',
					name: 'newpassword',
					component: () => import('@/views/pages/NewPassword.vue'),
				},
			]
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	],
})

router.beforeEach((to, from, next) => {

  	const loggedIn = mixins.methods.isLoggedIn();
  	const userRole = mixins.methods.getUserRole();
  	const isStaff = mixins.methods.isStaff();
  	const forceLoginChange = mixins.methods.forceLoginChange();

	if (!to.meta.public && (!loggedIn || localStorage.getItem('userSession') === null)) {
		next({
			name:'pageLogin',
		    query: {redirect: to.name}  // Store the name redirect the user to after login
		});
		return;
	}else if (forceLoginChange == 1) {
		if(
			!(to.name == 'newpassword') &&
			(!(to.meta && to.meta.public == true)) &&
			!(to.name == 'home') //&&
			// !(to.name == 'pageLogin')
			){

			next({name: 'pageLogin'});
			return;
		}
	}else if ((to.meta.staff || to.meta.permission) && loggedIn) {
		var youGo = false;

		// entra se tiver na meta staff: true e for staff
		if(typeof to.meta.staff !== 'undefined'){
			if(isStaff == null){
				youGo = null;
			}else{
				youGo = to.meta.staff && isStaff ? true : youGo;
			}
			
		}
		// entra se tiver na meta permission e for (userRole = 3 ou userRole in permission)
		if(typeof to.meta.permission !== 'undefined'){
			let permission = to.meta.permission;
			if(userRole != null){
				if(userRole == 3){
					youGo = true;
				}else if (permission.indexOf(parseInt(userRole)) !== -1) {
					youGo = true;
				} else {
					youGo = false;
				}
			}else{
				youGo = null;
			}
		}

		if(youGo !== null){
			if(youGo){
				if(forceLoginChange == 1){
					next({name: 'newpassword'});
				}else{
					next();
				}
			}else{
				next({name: 'pageError404'});
				return;
			} 
		}
	}
    
    next();
    
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = "none";
	}
})

export default router
